import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'

const useDateFormatter = () => {
  /**
   * Receives string(ISO) date param and return long formatted date with time
   * @param {String} dateValue
   * @returns {String}
   * Hoje às 14:19 or
   * Ontem às 14:19 or
   * 09/06/2022 às 14:19
   */
  const formatDateTime = (dateValue: string): string => {
    if (!dateValue) {
      return ''
    }
    const date = getDate(dateValue)
    let dateString = date.toLocaleString('pt-BR', {
      dateStyle: 'short'
    })
    if (isToday(date)) {
      dateString = 'Hoje'
    } else if (isYesterday(date)) {
      dateString = 'Ontem'
    }

    const time = date.toLocaleTimeString('pt-BR', {
      timeStyle: 'short'
    })
    return `${dateString} às ${time}`
  }

  /**
   * Receives a date and return a string with date formatted
   * @param date
   * @returns
   */
  const formatDate = (date: Date) => {
    return (
      ('0' + date.getDate()).slice(-2) +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      date.getFullYear()
    )
  }

  const timeDifference = (date: Date | number | string) => {
    if (!date) return 'sem data'

    const msPerSecond = 1000
    const msPerMinute = msPerSecond * 60
    const msPerHour = msPerMinute * 60
    const msPerDay = msPerHour * 24
    const msPerMonth = msPerDay * 30
    const msPerYear = msPerDay * 365

    function getDateInMs(date: Date | number | string) {
      return date instanceof Date ? date.getTime() : Number(date) * msPerSecond
    }

    function getSuffix(quantity: number) {
      return quantity > 1 ? 's' : ''
    }

    const previous = getDateInMs(date)
    const elapsed = new Date().getTime() - previous

    if (elapsed < msPerMinute) {
      const seconds = Math.round(elapsed / msPerSecond)
      return `${seconds} seg${getSuffix(seconds)}`
    } else if (elapsed < msPerHour) {
      const minutes = Math.round(elapsed / msPerMinute)
      return `${minutes} min${getSuffix(minutes)}`
    } else if (elapsed < msPerDay) {
      const hours = Math.round(elapsed / msPerHour)
      return `${hours} h`
    } else if (elapsed < msPerMonth) {
      const days = Math.round(elapsed / msPerDay)
      return `${days} dia${getSuffix(days)}`
    } else if (elapsed < msPerYear) {
      const months = Math.round(elapsed / msPerMonth)
      return `${months} ${months > 1 ? 'meses' : 'mês'}`
    }
    const years = Math.round(elapsed / msPerYear)
    return `${years} ano${getSuffix(years)}`
  }

  const getDate = (dateValue: string): Date => {
    dateValue = dateValue + 'Z'
    return new Date(dateValue)
  }

  return {
    formatDateTime,
    formatDate,
    timeDifference
  }
}

export default useDateFormatter
